import { TextFieldHelper } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2PaymentTeaserDialog extends Poker2Dialog {
    public static NAME: string = "PokerPaymentTeaserDialog";

    constructor(disp: Container) {
        super(disp);
    }

    public get isUnique(): boolean {
        return false;
    }

    protected init(): void {
        super.init();
        this.teaserDialog.tooltip._1.allowFastGlow = false;
        this.teaserDialog.tooltip._1.doCache();
    }

    protected applyProperties(): void {
        var chips: string = Poker2Model.languageData.getTextById("dialog_ranking_chips");
        super.applyProperties();
        this.teaserDialog.btn_addmoney.label = Poker2Model.languageData.getTextById("generic_payment_btn");
        TextFieldHelper.changeTextFromatSizeByTextWidth(21, this.teaserDialog.txt_title, Poker2Model.languageData.getTextById("generic_discount_payment_title_general", [chips]));
        if (Poker2Model.sessionData.specialOffer_RegisterBonus) {
            this.teaserDialog.txt_copy.text = Poker2Model.languageData.getTextById("generic_payment_48hdiscount_copy_1_general", [chips, Poker2Model.sessionData.highestSpecialOffer]);
        }
        else {
            this.teaserDialog.txt_copy.text = Poker2Model.languageData.getTextById("generic_payment_discount_copy_general", [chips, Poker2Model.sessionData.highestSpecialOffer]);
        }

        /*
        switch(Poker2Model.sessionData.highestSpecialOffer)
        {
                case 20:
                    teaserDialog.mc_bonus.gotoAndStop(1);
                    break;
                case 50:
                    teaserDialog.mc_bonus.gotoAndStop(2);
                    break;
                case 100:
                    teaserDialog.mc_bonus.gotoAndStop(3);
                    break;
                default:
                    teaserDialog.mc_bonus.gotoAndStop(1);
        }
        teaserDialog.txt_time.text = Poker2Model.languageData.getTextById("generic_payment_discount_time", [
            TimeStringHelper.getTimeToString( Poker2Model.sessionData.specialOffer_Delay, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById) ])
        */
        this.teaserDialog.tooltip.txt_time1.text = Poker2Model.languageData.getTextById("generic_payment_discount_time", [""]);
        var timeStr: string = TimeStringHelper.getTimeToString(Poker2Model.sessionData.specialOffer_Delay, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData), false, true);
        this.teaserDialog.tooltip.txt_time2.text = timeStr;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.teaserDialog.btn_close:
                this.hide();
                break;
            case this.teaserDialog.btn_addmoney:
                this.controller.addExtraGold();
                this.hide();
                break;
        }
    }

    private get teaserDialog(): Library.PokerPopUps.PaymentBonusPopUp {
        return this.disp as Library.PokerPopUps.PaymentBonusPopUp;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set isUnique(value/*:Boolean*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Dialog.prototype, "isUnique").set.call(this, value);
    }
}
